import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36701ca6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=36701ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36701ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36701ca6')) {
      api.createRecord('36701ca6', component.options)
    } else {
      api.reload('36701ca6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36701ca6&scoped=true&", function () {
      api.rerender('36701ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/integral/collect/index.vue"
export default component.exports